import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import SnackbarUtils from "../../../libs/SnackbarUtils";
import historyUtils from "../../../libs/history.utils";
import { isDate } from "../../../libs/RegexUtils";
import { serviceGetZone } from "../../../services/Zone.service";

const useZoneDashboard = ({}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startValid, setStartValid] = useState(false);
  const [endValid, setEndValid] = useState(false);

  const handleChangeDate = useCallback(
    (Date, name) => {
      if (name == "start") {
        setStartDate(Date);
        setStartValid(false);
      } else if (name == "end") {
        setEndDate(Date);
        setEndValid(false);
      }
    },
    [
      startDate,
      setStartDate,
      setEndDate,
      endDate,
      startValid,
      endValid,
      setStartValid,
      setEndValid,
    ]
  );

  const resetData = useCallback(() => {
    setIsSubmitting(true);

    serviceGetZone({
      start_date: startDate,
      end_date: endDate,
      index: 1,
      query: null,
      query_data: null,
      // ...value,
    }).then((res) => {
      if (!res.error) {
        const data = res.data;
        setApiData(data);
      }
      setIsSubmitting(false);
    });
  }, [setIsSubmitting, startDate, endDate]);

  const checkValidation = (start, end) => {
    if (!isDate(start) || !isDate(end)) {
      if (!isDate(start)) {
        setStartValid(true);
      }
      if (!isDate(end)) {
        setEndValid(true);
      }
      return false;
    }
    if (start && end) {
      const startDate = new Date(start);
      const endDate = new Date(end);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);
      if (startDate.getTime() > endDate.getTime()) {
        SnackbarUtils.error("End Date should not be Less than Start Date");
        setStartValid(true);
        setEndValid(true);
        return false;
      }
    }
    setStartValid(false);
    setEndValid(false);
    return true;
  };

  const initialApiCall = useCallback(() => {
    const checkVaid = checkValidation(startDate, endDate);
    if (startDate && endDate && checkVaid) {
      resetData();
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (startDate && endDate) {
      initialApiCall();
    }
  }, [startDate, endDate]);

  const handleViewDetails = useCallback((data) => {
    historyUtils.push(`/employees/details/${data?.emp_code}`);
  }, []);

  return {
    initialApiCall,
    handleViewDetails,
    isSubmitting,
    startDate,
    endDate,
    handleChangeDate,
    startValid,
    endValid,
    apiData
  };
};

export default useZoneDashboard;
